import _ from 'lodash';
import moment from 'moment';
import config from '~/config';

const keepOffset = ! config.get( 'utcTimestamps', false );

export function now() {
  return moment().toISOString( keepOffset );
}
